import React from 'react';
import { useNavigate } from 'react-router-dom';

interface CTASectionProps {
    highlightColor: {
        primary: string;
        hover: string;
        gradient: {
            from: string;
            to: string;
            fromBlue: string;
            toPurple: string;
        };
    };
}

const CTASection: React.FC<CTASectionProps> = ({ highlightColor }) => {
    const navigate = useNavigate();
    return (
        <section className="pt-12 pb-36 px-4 sm:px-6 lg:px-8 bg-black relative">
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white/10 to-transparent pointer-events-none"></div>
            <div className="max-w-7xl mx-auto relative z-10">
                <div className="bg-neutral-900 rounded-xl p-12 text-center observe-fade opacity-0 border border-neutral-800">
                    <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
                        Give your team the competitive edge.
                    </h3>
                    <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
                        Join teams across all levels who trust CGM Sports to optimize performance, prevent injuries, and make data-driven coaching decisions. 
                        Connect your wearable devices today and start receiving AI-powered insights immediately.
                    </p>
                    <button 
                        onClick={() => navigate('/register')}
                        className="px-8 py-4 text-lg text-white rounded-lg transition-colors font-medium"
                        style={{ backgroundColor: highlightColor.primary }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = highlightColor.hover;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = highlightColor.primary;
                        }}
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CTASection;

